module.exports = __webpack_public_path__ + "images/help_v2/case-gudong-d630c07a92ee94b2e7d83bd2d5d60083.jpg";